<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/']}]"></app-logo-area>
<main>
  <app-headline-section [title]="'Welcome'"></app-headline-section>
  @if (loading) {
    <section class="cl-section cl-section-regular">
      <div class="container">
        <div class="row">
          <div class="col-12" style="text-align: center">
            <div class="cl-spinner">Loading Organizations ...<i class="fas fa-spinner fa-spin"></i></div>
          </div>
        </div>
      </div>
    </section>
  } @else {
    <section class="cl-section cl-section-regular">
      <div class="container">
        <div class="row">
          <div class="col-12">
            @if (organizations(); as orgs) {
              @if (orgs.length === 0) {
                <h1>No organization</h1>
                <p>None of your organizations is licensed for Content Platform.</p>
              } @else {
                <h1></h1>
                <div style="text-align: center">
                  <div class="cl-spinner">Redirecting ...<i class="fas fa-spinner fa-spin"></i></div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </section>

  }
</main>
